import { CanActivateFn } from '@angular/router';
import { environment } from './../../environments/environment';

export const testGuard: CanActivateFn = (route, state) => {
  return !environment.production;
};
